import BaseService from './base.service';

export default class RentalService {
    static ENDPOINT = '/rentals';

    static async getRentals() {
        return BaseService.get(this.ENDPOINT);
    }

    static async getRentalById(orgId, rentalId) {
        return BaseService.get(`${this.ENDPOINT}/org/${orgId}/${rentalId}`);
    }

    static async getRentalsByOrgId(orgId, params = {}) {
        return BaseService.get(`${this.ENDPOINT}/org/${orgId}`, params).then(response =>
            response.filter(rental => rental.property)
        );
    }

    static async getRentalOrgProperties(orgId) {
        return BaseService.get(`${this.ENDPOINT}/org/${orgId}/properties`);
    }

    static async getOrgRentalManagers(orgId) {
        return BaseService.get(`${this.ENDPOINT}/org/${orgId}/get-rental-managers`);
    }

    static async getOrgPrimaryRentalManagers(orgId) {
        return BaseService.get(`${this.ENDPOINT}/org/${orgId}/primary-rental-managers`);
    }

    static async getRentalsByPropertyId(orgId, propertyId) {
        return BaseService.get(`${this.ENDPOINT}/org/${orgId}/property/${propertyId}`);
    }

    static async findUserByPhoneNumber(phoneNumber) {
        return BaseService.get(`${this.ENDPOINT}/users/find-user`, { phoneNumber });
    }

    static async findUser(phoneOrEmail) {
        return BaseService.get(`${this.ENDPOINT}/users/find-user`, { phoneOrEmail });
    }

    static async createRental(orgId, rentalData) {
        return BaseService.post(`${this.ENDPOINT}/org/${orgId}`, rentalData);
    }

    static async updateRental(orgId, rentalId, rentalData) {
        return BaseService.patch(`${this.ENDPOINT}/org/${orgId}/${rentalId}`, rentalData);
    }

    static async cancelRental(orgId, rentalId) {
        return BaseService.patch(`${this.ENDPOINT}/org/${orgId}/${rentalId}/cancel`, {});
    }

    static async updateOrgRentalCheckTimes(orgId, rentalCheckTimes) {
        return BaseService.patch(
            `${this.ENDPOINT}/orgs/${orgId}/update-rental-check-times`,
            rentalCheckTimes
        );
    }

    static async syncPropertyManagers(orgId, propertyId, userIds) {
        return BaseService.patch(
            `${this.ENDPOINT}/org/${orgId}/property/${propertyId}/sync-property-managers`,
            userIds
        );
    }

    static async syncOwnerManagedForProperty(orgId, propertyId, ownerManaged) {
        return BaseService.patch(
            `${this.ENDPOINT}/org/${orgId}/property/${propertyId}/sync-owner-managed`,
            ownerManaged
        );
    }

    static async removeRentalManagerFromProperty(orgId, propertyId, userId) {
        const endpoint = `${this.ENDPOINT}/org/${orgId}/property/${propertyId}/rental-managers/${userId}/remove`;
        return BaseService.patch(endpoint, {});
    }

    static async syncInvitedManagers(orgId, propertyId, inviteIds) {
        return BaseService.patch(
            `${this.ENDPOINT}/org/${orgId}/property/${propertyId}/sync-invited-managers`,
            inviteIds
        );
    }
}
